export const DISPUTE_REASONS = {
  GENERAL: 'General',
  CARDHOLDER_DISPUTE: 'Cardholder Dispute',
  CREDIT_NOT_PROCCESSED: 'Credit not processed',
  GOODS_OR_SERVICES_NOT_PROVIDE: 'Goods or Services Not Provided',
  PRODUCT_UNACCEPTEABLE: 'Product unacceptable',
  SUBSCRIPTION_CANCELED: 'Subscription canceled',
  COUNTERFEIT_MERCHANDISE: 'Counterfeit Merchandise',
  FRAUD: 'Fraud',
  PROCESSING_ERRORS: 'Processing Errors',
  AUTHORIZATION: 'Authorization Errors',
};

export const ACCEPTED_FILES_TYPES = '.pdf';
export const MAX_FILE_MB_SIZE = 5;

export enum DisputeType {
  AUTHORIZATION = 'authorization',
  PAYMENT = 'payment',
}

export const DISPUTE_STATUS_RAPYD_API = {
  ACTIVE: 'ACT',
  REVIEW: 'RVW',
  LOSE: 'LOS',
  WIN: 'WIN',
  REV: 'REV',
};
